module.exports = __webpack_public_path__ + "img/download.d0289dc0.png";